import React, { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

export default function SecretAdminLogin({ children }: { children?: React.ReactNode }) {
  const [clickCount, setClickCount] = useState(0)
  const timerRef = useRef<NodeJS.Timeout | null>(null)
  const navigate = useNavigate()

  const handleClick = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    const newCount = clickCount + 1

    if (newCount === 2) {
      setClickCount(0)
      navigate('/sign-in-me')
    } else {
      setClickCount(newCount)
      timerRef.current = setTimeout(() => {
        setClickCount(0)
      }, 2000)
    }
  }

  if (children) {
    return <div onClick={handleClick}>{children}</div>
  }

  return (
    <footer className="bg-gray-100 text-center py-6 text-sm text-gray-500">
      &copy; {new Date().getFullYear()} Institut für Stillberatung. Alle Rechte vorbehalten.
    </footer>
  )
}
